window.config = {
	title: '浙江纳智金属科技有限公司',
	project: 'nazhi',
	app: 'admin',
	company: 'admin',
	domain: 'https://wz-nazhi.com',
	url: 'https://wz-nazhi.com/nazhi',
	baseURL: 'https://wz-nazhi.com/api/public/index.php',
	importTemplate: 'https://wz-nazhi.com/api/public',
	socket: 'wss://wz-nazhi.com/wss',
	wechaty: 'https://wz-nazhi.com/wechaty/api',
	systemmodule: ['cooperate'],
	logincompany: [{
			id: 'admin',
			title: '浙江纳智金属科技有限公司',
			app: 'admin',
			company:'admin',
			baseURL: 'https://wz-nazhi.com/api/public/index.php',
			dingtalk: {
				client_id: 'dingsxu2yqzlpb7w9296'
			}
		},
		{
			id: 'liuti',
			title: '温州磐视流体有限公司',
			app: 'liuti',
			company:'liuti',
			baseURL: 'https://wz-nazhi.com/api/public/liuti.php'
		}
	],
	dingtalk: null,
	// difyChatbotConfig: {
	// 	token: 'dY9pwH4siZTRFBkj',
	// 	baseUrl: 'http://47.99.117.136:9898'
	// },
	oss: {
		custom_domain: 'oss.wz-nazhi.com',
		aliyun_domain: 'nazhi.oss-cn-hangzhou.aliyuncs.com',
		region: 'oss-cn-hangzhou',
		accessKeyId: 'LTAI5tFdHZVMtBtiJUa2xEgJ',
		accessKeySecret: 'LERxsvzYzq1JaYRHdIs6m93rFbePm4',
		bucket: 'nazhi'
	},
	// chrome: {
	// 	eventlistener(event) {
	// 		if (event.data.event === "nazhi_postcookies") {
	// 			//console.log(event.data)
	// 			if (event.data.target === 'wlnwms') {
	// 				window.localStorage.setItem('wlnwms_cookies', event.data.cookies)
	// 			}
	// 			if (event.data.target === 'wln') {
	// 				window.localStorage.setItem('wln_cookies', event.data.cookies)
	// 			}
	// 		}

	// 	},
	// 	request(config) {
	// 		window.postMessage({
	// 				event: "nazhi_getcookies",
	// 				target: "wlnwms"
	// 			},
	// 			"*"
	// 		);
	// 		window.postMessage({
	// 				event: "nazhi_getcookies",
	// 				target: "wln"
	// 			},
	// 			"*"
	// 		);
	// 		let extracookies = []
	// 		let wlnwms_cookies = window.localStorage.getItem('wlnwms_cookies')
	// 		let wln_cookies = window.localStorage.getItem('wln_cookies')
	// 		if (wlnwms_cookies) {
	// 			extracookies.push('NAZHI_WLNWMS' + wlnwms_cookies + 'NAZHI_WLNWMS')
	// 		}
	// 		if (wln_cookies) {
	// 			extracookies.push('NAZHI_WLN' + wln_cookies + 'NAZHI_WLN')
	// 		}
	// 		config.headers.extracookies = extracookies.join('')

	// 	}
	// },
	equipment: [{
		name: '摄像头',
		code: 'carmera'
	}]
}